<template>
    <div>
        <div class="slick position-relative my-4">
            <div class="item-slick text-center cursor-pointer" v-on:click="nombreComposicion">
                <div class="bg-blanco d-flex align-items-center justify-content-center content-slick">
                    <i class="icon-plus font-45 texto-rojo-oscuro"></i>
                </div>
                <div class="font-weight-bold mt-2">Personalizado</div>
            </div>
            <div class="item-slick text-center cursor-pointer" v-for="(template, key) in templates" v-on:click="modalClonar(key)">
                <div class="bg-blanco d-flex align-items-center justify-content-center content-slick" v-bind:style="{ backgroundImage: `url(${urlbase}${template.imagen_template})` }"></div>
                <div class="font-weight-bold mt-2">{{template.nombre}}</div>
            </div>
        </div>
        <div class="modal fade" id="modalnotificaciones" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title text-center" id="modalLabel"></h5>
                            <div class='close-modal position-absolute cursor-pointer font-22' data-dismiss='modal' aria-label='Close'><i class='icon-cancel-circled'></i></div>
                        </div>
                        <div class="modal-body text-center font-12 texto-gris"></div>
                        <div class="form-group text-center clearfix mb-4">
                            <button v-on:click="crearComposicion" class="btn radio-10 font-12 btn-sm mx-1 px-4 btn-morado-base d-inline-flex align-items-center">Crear saludo</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalclonar" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title text-center"></h5>
                            <div class='close-modal position-absolute cursor-pointer font-22' data-dismiss='modal' aria-label='Close'><i class='icon-cancel-circled'></i></div>
                        </div>
                        <div class="modal-body text-center font-12 texto-gris">
                            <input type="text" v-model="$v.nombrecomposicion.$model" class="form-control" placeholder="Colocale un nombre a tu saludo">
                        </div>
                        <div class="mb-3" v-show="$v.nombrecomposicion.$error">
                            <div class="font-10 text-center texto-rojo font-italic">El nombre debe tener mínimo 4 caracteres y sin caracteres especiales</div>
                        </div>
                        <div class="form-group text-center clearfix mb-4">
                            <button v-on:click="clonarComposicion()" class="btn radio-10 font-12 btn-sm mx-1 px-4 btn-morado-base d-inline-flex align-items-center">Crear saludo</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { modalnotificaciones, modaldata, slickcarousel } from '@resources/helpers.js'
    import { required, minLength, helpers } from '@public/validators.min'
    const customname = helpers.regex('customname', /^[a-zA-ZñÑáéíóúAÉÍÓÚ\d\-_\s]+$/i)
    const instance = axios.create({
        headers: {'Authorization': 'Bearer '+document.querySelector("#mkap_token").value}
    });
    let titulomodal = 'Aviso'
    export default {
        data () {
            return {
                nombrecomposicion: '',
                composicionaclonar: '',
                templates: {},
                urlbase: $("#app_url").val()+'img/plantillas/'
            }
        },
        validations: {
            nombrecomposicion: { required, minLength: minLength(4), customname }
        },
        mounted () {
            instance.get('obtenertemplates')
                .then(response => {
                    this.templates = response.data
                })
                .catch(error => {
                    modalnotificaciones('Aviso', 'Verifique su conexion a internet', '', '#modalavisoindex')
                })
                .finally(
                    slickcarousel
                )
        },
        methods: {
            nombreComposicion (){
                modalnotificaciones('Desea crear un nuevo saludo',' ')
            },
            crearComposicion (){
                let self = this
                instance.post('composicion', {
                        token : document.querySelector("#mkus_token").value,
                        id_tipo : 1,
                        codigo_board : '',
                        codigo_card : '',
                        card_name : ''
                    })
                    .then(response => {
                        window.location.href = document.querySelector("#app_url").value+"editar-maketa/"+response.data;
                    })
                    .catch(error => {
                        $(".close-modal").trigger( "click" );
                        modalnotificaciones(titulomodal, 'No se pudo crear el saludo.', '', '', '#modalavisoindex')
                    })
            },
            modalClonar (key){
                this.composicionaclonar = this.templates[key].codigo_hash
                modaldata('Usa este saludo', '', '', '#modalclonar')
            },
            clonarComposicion (){
                let self = this
                self.$v.$touch()
                if (self.$v.$invalid) {

                } else {
                    instance.post('composicion/clone', {
                            token : document.querySelector("#mkus_token").value,
                            token_maketa : self.composicionaclonar,
                            nuevo_nombre : self.nombrecomposicion,
                            codigo_card : '',
                            card_name : '',
                            final : 1,
                        })
                        .then(response => {
                            window.location.href = document.querySelector("#app_url").value+"editar-maketa/"+response.data;
                        })
                        .catch(error => {
                            $(".close-modal").trigger( "click" );
                            modalnotificaciones(titulomodal, 'No se pudo clonar el saludo', '', '', '#modalavisoindex')
                        })
                }
            }
        }

    }
</script>
